import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetSchedulesRequest } from 'app/generated/backend/shipment/api/get-schedules-request';
import { GetSchedulesResponse } from 'app/generated/backend/shipment/api/get-schedules-response';

@Injectable()
export class GetSchedulesHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: GetSchedulesRequest
	): Observable<JsonResourceResponse<GetSchedulesResponse>> {
		return this.http.post<JsonResourceResponse<GetSchedulesResponse>>('api/v1/shipment/getSchedules', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		GetSchedulesHandlerService
	]
})
export class GetSchedulesHandlerModule { }
